import getApiInstance from 'data/common/ApiCallGenerique';
import Translator from 'translator';
import { Logger, Toastr } from 'data/common';
import api from './api';

const apiCaller = getApiInstance();

export function getCraftsmen(env) {
    return dispatch => {
        return apiCaller
            .call(api.getAllCraftsmen(env))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__SET_CRAFTSMEN`,
                        craftsmen: data.craftsmen
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setCraftsmen - ', error);
                throw error;
            });
    };
}
export function getCraftsmanDetails(env, craftsmanId) {
    return dispatch => {
        return apiCaller
            .call(api.getCraftsmanDetails(env, craftsmanId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__SET_CRAFTSMAN`,
                        craftsmanId,
                        craftsman: data.craftsman
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('CraftsmanActions - getCraftsmanDetails - ', error);
                throw error;
            });
    };
}
export function updateCraftsmanDetails(env, craftsmanId, craftsmanForm) {
    return dispatch => {
        return apiCaller
            .call(api.updateCraftsmanDetails(env, craftsmanId, craftsmanForm))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__UPDATE_CRAFTSMAN`,
                        craftsmanId,
                        craftsman: data.craftsman
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: updateCraftsmanDetails - ', error);
                throw error;
            });
    };
}
export function addCraftsman(env, craftsmanForm) {
    return dispatch => {
        return apiCaller
            .call(api.addCraftsman(env, craftsmanForm))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__SET_CRAFTSMAN`,
                        craftsman: data.craftsman,
                        craftsmanId: data.craftsmanId
                    });
                    if (data.intermediateError) {
                        Logger.warn('dataActions: addCraftsman - ', data.intermediateError);
                        Toastr.warning(
                            Translator.translateWithFallback(
                                `api.message.env, ${
                                    data.intermediateError.response ? data.intermediateError.response : data.intermediateError.message
                                }`,
                                'api.message.env, default'
                            ),
                            Translator.translate('api.message.env, intermediate_error')
                        );
                    }
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: addCraftsman - ', error);
                throw error;
            });
    };
}

export function getCraftsmanTickets(env, craftsmanId) {
    return () => {
        return apiCaller
            .call(api.getCraftsmanTickets(env, craftsmanId))
            .then(({ data }) => {
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: getCraftsmanTickets - ', error);
                throw error;
            });
    };
}

export function resetPassword(env, craftsmanId, craftsmanForm) {
    return () => {
        return apiCaller
            .call(api.resetPassword(env, craftsmanId, craftsmanForm))
            .then(({ data }) => {
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setResetPassword - ', error);
                throw error;
            });
    };
}



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Craftsman/actions.js